import { useEffect, useState } from "react";
import DataNotFound from "../ui/loader/data-not-found";
import InnerLoader from "../ui/loader/inner-loader";
import { useApiCall } from "../custom-hooks/api-call";
import { Link, useNavigate } from "react-router";
import { ChartMainCard } from "./ChartsHeader";
import { TeamAvailability } from "./StatCardIcons";
import Icon from "../icons/inner-pages-icons";

// const leads = [
//   {
//     id: 1,
//     leadName: "Collins",
//     product: "Marketing Automation",
//     status: "Contacted",
//     statusColor: "bg-blue-100 text-blue-700",
//     time: "14/01/2024 10:30 AM",
//     action: "Follow Up",
//     owner: "Hendry",
//   },
//   {
//     id: 2,
//     leadName: "Konopelski",
//     product: "CRM Platform",
//     status: "Closed",
//     statusColor: "bg-green-100 text-green-700",
//     time: "21/01/2024 2:45 PM",
//     action: "Send Invoice",
//     owner: "Guilory",
//   },
//   {
//     id: 3,
//     leadName: "Adams",
//     product: "AI Analytics",
//     status: "Lost",
//     statusColor: "bg-red-100 text-red-700",
//     time: "20/02/2024 11:15 AM",
//     action: "Review",
//     owner: "Jami",
//   },
//   {
//     id: 4,
//     leadName: "Schumm",
//     product: "Eco-Friendly Packaging",
//     status: "Not Contacted",
//     statusColor: "bg-purple-100 text-purple-700",
//     time: "15/03/2024 9:00 AM",
//     action: "Reach Out",
//     owner: "Theresa",
//   },
//   {
//     id: 5,
//     leadName: "Wisozk",
//     product: "Cloud Hosting",
//     status: "Closed",
//     statusColor: "bg-green-100 text-green-700",
//     time: "12/04/2024 3:20 PM",
//     action: "Send Report",
//     owner: "Smith",
//   },
//   {
//     id: 6,
//     leadName: "Bergnaum",
//     product: "Cybersecurity Suite",
//     status: "Contacted",
//     statusColor: "bg-blue-100 text-blue-700",
//     time: "05/05/2024 1:10 PM",
//     action: "Schedule Demo",
//     owner: "Laura",
//   },
//   {
//     id: 7,
//     leadName: "Kuhn",
//     product: "Data Integration",
//     status: "Not Contacted",
//     statusColor: "bg-purple-100 text-purple-700",
//     time: "18/05/2024 4:00 PM",
//     action: "Initial Call",
//     owner: "Derek",
//   },
//   {
//     id: 8,
//     leadName: "Hodkiewicz",
//     product: "UX Consulting",
//     status: "Lost",
//     statusColor: "bg-red-100 text-red-700",
//     time: "23/06/2024 11:45 AM",
//     action: "Review Notes",
//     owner: "Monica",
//   },
//   {
//     id: 9,
//     leadName: "Roberts",
//     product: "E-Commerce Platform",
//     status: "Contacted",
//     statusColor: "bg-blue-100 text-blue-700",
//     time: "02/07/2024 2:30 PM",
//     action: "Send Proposal",
//     owner: "Alex",
//   },
//   {
//     id: 10,
//     leadName: "Johns",
//     product: "Digital Marketing",
//     status: "Closed",
//     statusColor: "bg-green-100 text-green-700",
//     time: "15/07/2024 10:00 AM",
//     action: "Invoice Sent",
//     owner: "Rachel",
//   },
// ];

const priorityColors = { high: "#ef4444", medium: "#f59e0b", low: "#10b981" };

const Badge = ({ color, children, style = {} }) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      padding: "3px 10px",
      borderRadius: 6,
      fontSize: 11,
      fontWeight: 600,
      background: color + "14",
      color,
      letterSpacing: "0.3px",
      ...style,
    }}
  >
    {children}
  </span>
);

const activityIcons = {
  call: "phone",
  phone: "phone",
  email: "mail",
  sms: "sms",
  consultation: "consultation",
  default: "default",

  note: "note",
  meeting: "calendar",
  "follow-up": "calendar",
  followup: "calendar",
  stage: "arrowRight",
  voicemail: "mic",
  chat: "sms",
  comment: "sms",
  demo: "demo",
  messasge: "sms",
  presentation: "presentation",
  assign: "assign",
  unassign: "unassign",
  file: "file",
  brief: "brief",
};

const activityColors = {
  call: "#3b82f6", // blue
  email: "#8b5cf6", // violet
  sms: "#06b6d4", // cyan
  consultation: "#f59e0b", // amber
  note: "#f59e0b", // amber
  meeting: "#10b981", // emerald
  stage: "#6366f1", // indigo
  // "follow-up": "#6366f1", // indigo
  "follow-up": "#06b6d4", // indigo
  voicemail: "#ef4444", // red

  chat: "#0ea5e9", // sky blue
  presentation: "#14b8a6", // teal
  demo: "#a855f7", // purple
  default: "#a855f7", // purple
  messasge: "#f43f5e", // rose

  // remaining icons (added)
  phone: "#3b82f6", // blue
  comment: "#0ea5e9", // sky
  followup: "#06b6d4", // indigo
  assign: "#22c55e", // green
  unassign: "#ef4444", // red
  file: "#eab308", // slate
  brief: "#eab308", // yellow
};
export function TodayFollowups({ view, leads, count, loading = false }) {
  // const [recentLeads, setRecentLeads] = useState([]);
  // const [recentLoading, setRecentLoading] = useState(true);
  const apiCall = useApiCall();
  const navigate = useNavigate();

  // const getRecentLeads = async () => {
  //   setRecentLoading(false);

  //   const apiUrl = `leads/get-leads?view=${view}`;

  //   try {
  //     const res = await apiCall({ method: "get", url: apiUrl });

  //     const top10 = Array.isArray(res?.data)
  //       ? res.data.slice(0, 10) // first 10 items
  //       : [];

  //     setRecentLeads(top10);
  //   } catch (error) {
  //     console.warn("Error fetching brand data:", error);
  //   } finally {
  //     setRecentLoading(true);
  //   }
  // };

  // useEffect(() => {
  //   // getRecentLeads();
  // }, []);

  const StatusTag = ({ status, statusColor }) => {
    return (
      <span
        className={`inline-block px-3 py-1 text-[12px] font-semibold rounded-full text-center ${statusColor}`}
      >
        {status}
      </span>
    );
  };

  return (
    <ChartMainCard
      Icon={<TeamAvailability />}
      // iconColor={'bg-theme-purple-light text-theme-purple'}
      iconColor={"bg-[#FEE2E2] text-[#FF4040]"}
      heading="Today’s Follow Ups"
      subHeading={"Scheduled tasks requiring attention today"}
      count={count}
    >
      {!loading ? (
        <div className="max-h-[430px] min-h-[430px] overflow-auto">
          {leads?.length > 0 ? (
            <table className="min-w-full">
              <thead className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                    Title
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                    Time
                  </th>
                  <th className="px-4 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">
                    Priority
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                    Notes
                  </th>
                </tr>
                {/* <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Lead
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Product
                </th>
                <th className="px-6 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Action
                </th>
              </tr> */}
              </thead>

              <tbody className="divide-y divide-gray-200">
                {leads?.map((lead) => {
                  const color =
                    activityColors[lead?.type?.toLocaleLowerCase()] ||
                    "#8b5cf6" ||
                    "#6b7280";
                  return (
                    //  to={`/lead-account/detail/${eachList?.userid}/account`}

                    <tr
                      key={lead.id}
                      className="hover:bg-gray-100 cursor-pointer transition-all duration-200"
                      // comment for now
                      // onClick={() => {
                      //   const type = lead?.entity_type;
                      //   const nav =
                      //     type == "lead" && lead?.entity_details?.leadid
                      //       ? // lead
                      //         `/leads/leadDetail/${lead?.entity_details?.leadid}`
                      //       : // deal
                      //         type == "deal" && lead?.entity_details?.dealid
                      //         ? `/lead-account/detail/${lead?.entity_details?.contactid}/deal/${lead?.entity_details?.dealid}`
                      //         : // contact
                      //           type == "contact" &&
                      //             lead?.entity_details?.userid
                      //           ? `/lead-account/detail/${lead?.entity_id}/contact`
                      //           : // account
                      //             type == "account" &&
                      //               lead?.entity_details?.userid
                      //             ? `/lead-account/detail/${lead?.entity_id}/account`
                      //             : // project
                      //               type == "project" &&
                      //                 lead?.entity_details?.projectkey
                      //               ? `/lead-account/detail/${lead?.entity_details?.customer}/project/${lead?.entity_details?.projectkey}`
                      //               : "/";
                      //   window.open(nav, "_blank"); // opens in a new tab
                      // }}
                      onClick={() => {
                        const type = lead?.entity_type;
                        const nav =
                          type == "lead" && lead?.entity_details?.leadid
                            ? // lead
                              `/leads/leadDetail/${lead?.entity_details?.leadid}/followup/${lead?.fup_id}`
                            : // deal
                              type == "deal" && lead?.entity_details?.dealid
                              ? `/lead-account/detail/${lead?.entity_details?.dealid}/deal/${lead?.entity_details?.dealid}/followup/${lead?.fup_id}`
                              : // contact
                                type == "contact" && lead?.entity_details?.userid
                                ? `/lead-account/detail/${lead?.entity_id}/contact/followup/${lead?.fup_id}`
                                : // account
                                  type == "account" && lead?.entity_details?.userid
                                  ? `/lead-account/detail/${lead?.entity_id}/account/followup/${lead?.fup_id}`
                                  : // project
                                    type == "project" &&
                                      lead?.entity_details?.projectkey
                                    ? `/lead-account/detail/${lead?.entity_details?.customer}/project/${lead?.entity_details?.projectkey}/followup/${lead?.fup_id}`
                                    : "/";
                        window.open(nav, "_blank"); // opens in a new tab
                      }}
                    >
                      <td className="px-4 py-3">
                        <div className="flex gap-2 items-center">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 5,
                              padding: "5px",
                              borderRadius: 20,
                              border: `1px solid ${activityColors[lead?.type?.toLocaleLowerCase() || "default"]}25`,
                              background:
                                activityColors[
                                  lead?.type?.toLocaleLowerCase()
                                ] + "08",
                              color:
                                activityColors[lead?.type?.toLocaleLowerCase()],
                              cursor: "pointer",
                              fontSize: 11,
                              fontWeight: 600,
                              fontFamily: "inherit",
                            }}
                            title={lead?.type}
                          >
                            <Icon
                              name={
                                activityIcons[
                                  lead?.type?.toLocaleLowerCase() || "default"
                                ]
                              }
                              size={13}
                              color={
                                activityColors[
                                  lead?.type?.toLocaleLowerCase() || "default"
                                ]
                              }
                            />
                          </div>
                          <div className="flex flex-col gap-[2px]">
                            <h6 className="font-semibold text-[12px] capitalize">
                              {lead?.entity_type == "project"
                                ? lead?.entity_details?.invoiceid
                                : lead?.entity_details?.name || "-"}
                            </h6>
                            <span className="text-[10px] font-semibold text-gray-600">
                              {lead?.entity_type || "-"}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <h6 className="font-medium text-[12px]">
                          {lead?.time || "-"}
                        </h6>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex justify-center items-center">
                          <Badge
                            color={
                              priorityColors[lead?.priority?.toLowerCase()]
                            }
                          >
                            {lead?.priority}
                          </Badge>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <h6 className="font-medium text-[12px]">
                          {lead?.note?.length > 12
                            ? lead?.note.slice(0, 12) + "..."
                            : lead?.note || "-"}
                        </h6>
                      </td>
                    </tr>

                    // <tr key={lead.id} className="hover:bg-gray-50">
                    //   <td className="px-6 py-4">
                    //     <h6 className="font-semibold text-[12px]">
                    //       {lead?.leadName?.trim() ? lead.leadName : "-"}
                    //     </h6>
                    //   </td>
                    //   <td className="px-6 py-4">
                    //     <h6 className="font-medium text-[12px]">
                    //       {lead?.product || "-"}
                    //     </h6>
                    //   </td>
                    //   <td className="px-6 py-4">
                    //     <h6 className="font-medium text-[12px] flex justify-center items-center">
                    //       <StatusTag status={lead.status} statusColor={lead.statusColor} />
                    //     </h6>
                    //   </td>

                    //   <td className="px-6 py-4">
                    //     <h6 className="font-medium text-[12px]">
                    //       {lead?.action || "-"}
                    //     </h6>
                    //   </td>
                    // </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <div className="flex justify-center items-center !h-full !w-full">
              <DataNotFound title={"Follow Ups"} />
            </div>
          )}
        </div>
      ) : (
        <InnerLoader />
      )}
    </ChartMainCard>
  );
}
